import { ToastStateHandler, UserApi } from '../../../api';
import { ICallback } from '../../../commonTypes/hook.types';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';
import { AppError, ErrorCodes, isErrorCode, getUserMessage } from '../../../api/utils/ErrorHandler';

interface ChangeBranchDto {
    branchId: string;
    userSub: string;
}

interface MessageInformationDto {
    name: string;
    initialBranch: string;
    destinationBranch: string;
}

const useHttpPostChangeBranch = () => {
    const { t } = useTranslation();
    const toastHandler = useContainer(ToastStateHandler);
    const userApi: UserApi = useContainer(UserApi);

    const exec = (info: ChangeBranchDto, messageInfo: MessageInformationDto, callback: ICallback) => {
        const { branchId, userSub } = info;
        const { name, initialBranch, destinationBranch } = messageInfo;

        const replaceOnErrorMessage = (message: string) => {
            return message.replace('(Member Name)', name).replace('(From Branch Name)', initialBranch).replace('(To Branch Name)', destinationBranch);
        };

        const { exec, abort } = userApi.changeBranch({
            body: { branchId },
            params: { userSub },
            onSuccess: response => {
                const successMessage = t('newNotifications.user.changeBranchSuccess');

                toastHandler.push(
                    'success',
                    t('newNotifications.user.changeBranchTitle'),
                    successMessage
                        .replace('(Member Name)', name)
                        .replace('(From Branch Name)', initialBranch)
                        .replace('(To Branch Name)', destinationBranch)
                );
                callback.onSuccess && callback.onSuccess(response);
            },
            onError: (error: AppError | string) => {
                if (typeof error === 'object' && isErrorCode(error, ErrorCodes.DIFFERENT_LEAVE_POLICIES)) {
                    const errorMessage = t('newNotifications.user.changeBranchPoliciesMissmatchError');
                    toastHandler.push('error', t('newNotifications.user.changeBranchTitle'), replaceOnErrorMessage(errorMessage));
                } else {
                    const fallbackMessage = t('newNotifications.user.changeBranchError');
                    const message = typeof error === 'object' ? getUserMessage(error, fallbackMessage) : fallbackMessage;
                    toastHandler.push('error', t('newNotifications.user.changeBranchTitle'), replaceOnErrorMessage(message));
                }
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpPostChangeBranch;
